import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value: number | null | undefined, currency = 'LKR'): string {
  return new Intl.NumberFormat('en-LK', { style: 'currency', currency, maximumFractionDigits: 2 }).format(value ?? 0);
}

export function formatDate(dateString: string): string {
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(new Date(dateString));
}

export function getInitials(name: string): string {
  return name
    .split(" ")
    .map((part) => part.charAt(0))
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

export function hashStringToColor(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const colors = [
    "#5B6AF0",
    "#14B8A6",
    "#F59E0B",
    "#EF4444",
    "#8B5CF6",
    "#EC4899",
    "#06B6D4",
    "#84CC16",
  ];
  return colors[Math.abs(hash) % colors.length];
}

export function groupByPrefix(names: string[]): Record<string, string[]> {
  const groups: Record<string, string[]> = {};
  for (const name of names) {
    const prefix = name.split(".")[0];
    if (!groups[prefix]) groups[prefix] = [];
    groups[prefix].push(name);
  }
  return groups;
}

/**
 * Constructs the absolute public storage URL using the configured API base URL,
 * following the exact pattern used for Business Logos:
 * `${process.env.NEXT_PUBLIC_API_BASE_URL}/storage/${relativePath}`
 */
export function getStorageUrl(path: string | null | undefined): string | null {
  if (!path) return null;

  if (path.startsWith('data:') || path.startsWith('blob:') || path.includes('ui-avatars.com')) {
    return path;
  }

  const base = process.env.NEXT_PUBLIC_API_BASE_URL ?? '';

  let relativePath = path;

  if (path.includes('/storage/')) {
    relativePath = path.substring(path.indexOf('/storage/') + 9);
  } else if (path.startsWith('/')) {
    relativePath = path.slice(1);
  }

  return `${base}/storage/${relativePath}`;
}

export const toApiStorageUrl = getStorageUrl;
